module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/P0twDr/tc-custom/9781611528664.jpg?1723406431981",
      "alt": "This image is the cover for the book Djinn Book 2: Where There's Smoke, Djinn"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Djinn Book 2: Where There's Smoke, Djinn\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("After Dale Edinger’s eccentric aunt passed away, she left him with a house full of clutter mixed with magical items and a djinn named Riadh. With his own history and a set of rules that make it impossible for him to be freed, Riadh now belongs to Dale. But when your skills at magic are one step above non-existent, you need a teacher."), _c('br'), _c('br'), _vm._v("Now Dale’s on the hunt for a teacher so he’ll not only learn how to wield magic, but will also be able to protect Riadh. Unfortunately, his options are limited. Who poses the greater risk -- a dragon with uncertain motives, or a big city mage who'd like to add Riadh to his own collection of possessions?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      A.R. Moler\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0